<script setup>
/**
 * "Suggested by Claude" on Answers (services spec §6 P-6.2, §8 P-8.4): the answers Claude drafted,
 * waiting. The assistant does not use them until she keeps them. Hidden when none waits.
 */
import { onMounted, ref } from 'vue';

import SettingsHeader from 'dashboard/components-next/captain/pageComponents/settings/SettingsHeader.vue';

import ClaudeAnswerDrafts from './ClaudeAnswerDrafts.vue';
import { useWasloI18n } from '../i18n.js';
import { wasloApi } from '../api/client.js';

const props = defineProps({
  accountId: { type: Number, default: null },
});

const emit = defineEmits(['changed']);

const { t } = useWasloI18n();
const drafts = ref([]);

const load = async () => {
  if (props.accountId === null) return;
  try {
    const items = await wasloApi.getSetupSuggestions(props.accountId, 'claude');
    drafts.value = items.filter(
      s => s.kind === 'answers' && s.status === 'open'
    );
  } catch {
    drafts.value = [];
  }
};

onMounted(load);
</script>

<template>
  <section
    v-if="drafts.length"
    class="flex flex-col gap-4"
    data-waslo-claude-answers-list
  >
    <SettingsHeader
      :heading="t('WASLO.CLAUDE.ANSWERS.HEADING')"
      :description="t('WASLO.CLAUDE.ANSWERS.DESCRIPTION')"
    />
    <!-- A Keep adds answers below: the list of all answers is redrawn, these follow themselves. -->
    <ClaudeAnswerDrafts
      v-for="s in drafts"
      :key="s.id"
      :account-id="accountId"
      :suggestion="s"
      @kept="emit('changed')"
    />
  </section>
</template>
